var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed top-0 left-0 w-screen h-screen overflow-auto bg-slate-100 scrollbar-lg",
      style: { zIndex: 999 }
    },
    [
      _c("div", { staticClass: "sticky top-0 left-0", style: { zIndex: 49 } }, [
        _c(
          "div",
          {
            staticClass:
              "flex flex-wrap items-center justify-between flex-shrink-0 h-10 px-6 lg:flex-no-wrap gap-y-2 gap-x-4 bg-pure-white"
          },
          [_c("BlBreadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex items-center justify-between px-6 border-b h-14 bg-pure-white border-slate-400"
          },
          [
            _c(
              "div",
              { staticClass: "flex items-center gap-4" },
              [
                _c("BlTextTitle4", {
                  attrs: { text: "Create new recurring appointments" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "flex items-center gap-4" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center gap-1 px-1 rounded max-w-80 h-7 bg-tulip-100",
                      attrs: { title: _vm.clientDataInput.name }
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "w-6 h-6",
                        attrs: { icon: "user-square", color: "tulip-7" }
                      }),
                      _vm._v(" "),
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate text-tulip-700",
                        attrs: { text: _vm.clientDataInput.name }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.clientDataInput.id
                    ? _c(
                        "div",
                        [
                          _vm.availableCredits < 1
                            ? _c("BlTextBody2", {
                                staticClass: "text-tomato-700",
                                attrs: { text: "No available credit(s)" }
                              })
                            : _c("BlTextBody2", {
                                staticClass: "text-lime-700",
                                attrs: {
                                  text:
                                    _vm.availableCredits +
                                    " available credit(s)"
                                }
                              })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center gap-4" },
              [
                _vm.counter <= _vm.alertCountdown &&
                _vm.bookingStatus === "in_progress"
                  ? _c("BlInputButton", {
                      attrs: {
                        type: "outlined",
                        label: "Extend by 5 minutes",
                        loading: _vm.extendLoading
                      },
                      on: { clicked: _vm.onExtendCountdown }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.bookingStatus === "in_progress"
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: {
                            icon: "timer",
                            color:
                              _vm.counter <= _vm.alertCountdown
                                ? "tomato-7"
                                : "slate-6"
                          }
                        }),
                        _vm._v(" "),
                        _vm.extendLoading
                          ? _c("div", { staticClass: "px-4" }, [
                              _c("div", { staticClass: "blum-loader-btn" })
                            ])
                          : _c("BlTextTitle4", {
                              class: [
                                _vm.counter <= _vm.alertCountdown
                                  ? "text-tomato-700"
                                  : "text-slate-700"
                              ],
                              attrs: { text: _vm.countdown }
                            })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("BlInputButton", {
                  attrs: {
                    type: "plain",
                    icon: "close",
                    loading: _vm.closeLoading
                  },
                  on: { clicked: _vm.onClickClose }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "absolute flex items-center justify-between w-full px-6 overflow-hidden transition-all duration-300 bg-tomato-700",
            class: [_vm.showAlertCountdown ? "h-9" : "h-0"]
          },
          [
            _c(
              "div",
              { staticClass: "flex items-center gap-2" },
              [
                _c("BlIcon", {
                  staticClass: "w-4 h-4",
                  attrs: { icon: "timer", color: "white" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("BlTextBody2", {
                      staticClass: "text-tomato-100",
                      attrs: {
                        text:
                          "Please complete the appointment process within the next "
                      }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "text-tomato-100",
                      attrs: {
                        text:
                          Math.ceil(_vm.counter / 60) +
                          " minute" +
                          (Math.ceil(_vm.counter / 60) > 1 ? "s" : "") +
                          " "
                      }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "text-tomato-100",
                      attrs: {
                        text:
                          "to avoid losing your timeslot and having to start over."
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("BlIcon", {
              staticClass: "w-4 h-4",
              attrs: { icon: "close", color: "white", clickable: "" },
              on: {
                clicked: function($event) {
                  _vm.showAlertCountdown = false
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.modalLoading
        ? _c("div", { staticClass: "grid h-100 place-items-center" }, [
            _c("div", { staticClass: "blum-loader" })
          ])
        : _vm.bookingStatus === "expired"
        ? _c(
            "div",
            {
              staticClass: "flex items-center justify-center",
              style: { height: "calc(100vh - 6rem - 2.5rem)" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col items-center gap-3 text-center w-132"
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-10 h-10",
                    attrs: { icon: "timer", color: "tomato-7" }
                  }),
                  _vm._v(" "),
                  _c("BlTextTitle4", {
                    staticClass: "text-tomato-700",
                    attrs: { text: "Booking time out" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "text-tomato-700",
                    attrs: {
                      text:
                        "The time limit has been reached, and and the selected timeslot is no longer available. Please restart the booking process to secure a new timeslot."
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: {
                      type: "outlined-error",
                      label: "Close",
                      loading: _vm.closeLoading
                    },
                    on: { clicked: _vm.onClickClose }
                  })
                ],
                1
              )
            ]
          )
        : _vm.bookingStatus === "completed"
        ? _c(
            "div",
            {
              staticClass: "flex items-center justify-center",
              style: { height: "calc(100vh - 6rem - 2.5rem)" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col items-center gap-3 text-center w-132"
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-32 h-32",
                    attrs: { icon: "check", color: "lime-6" }
                  }),
                  _vm._v(" "),
                  _c("BlTextTitle4", {
                    staticClass: "text-lime-700",
                    attrs: { text: "Booking completed" }
                  })
                ],
                1
              )
            ]
          )
        : _c(
            "div",
            [
              _vm.process === "select_client" && _vm.currentSlot
                ? _c("SelectClientRecurring", {
                    attrs: {
                      timeslotView: _vm.timeslotView,
                      timeslotViewOptions: _vm.timeslotViewOptions,
                      availability: _vm.availability,
                      currentSlot: _vm.currentSlot,
                      client: _vm.clientDataInput,
                      clientAppointments: _vm.clientAppointments,
                      submitLoading: _vm.submitLoading
                    },
                    on: {
                      "set-timeslot-view": function($event) {
                        _vm.timeslotView = $event
                      },
                      "set-client": _vm.onChangeClient,
                      continue: _vm.onCreateBooking
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.process === "manage_schedule"
                ? _c("ManageScheduleRecurring", {
                    attrs: {
                      timeslotView: _vm.timeslotView,
                      timeslotViewOptions: _vm.timeslotViewOptions,
                      clientAppointments: _vm.clientAppointments,
                      recurrence: _vm.recurrenceInput
                    },
                    on: {
                      "set-timeslot-view": function($event) {
                        _vm.timeslotView = $event
                      },
                      "set-recurrence": _vm.onChangeRecurrance,
                      "add-timeslot": function($event) {
                        _vm.process = "add_timeslot"
                      },
                      "edit-timeslot": _vm.openEditTimeslot,
                      "delete-timeslot": _vm.onDeleteTimeslot,
                      "open-previous": function($event) {
                        _vm.previousOpened = true
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.process === "add_timeslot"
                ? _c("HandleTimeslotRecurring", {
                    attrs: {
                      timeslotView: _vm.timeslotView,
                      timeslotViewOptions: _vm.timeslotViewOptions,
                      client: _vm.clientDataInput
                    },
                    on: {
                      "set-timeslot-view": function($event) {
                        _vm.timeslotView = $event
                      },
                      cancel: function($event) {
                        _vm.process = "manage_schedule"
                      },
                      continue: function($event) {
                        _vm.process = "manage_schedule"
                      },
                      "after-commit": function($event) {
                        return _vm.fetchAvailbleCredits(_vm.clientDataInput.id)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.process === "edit_timeslot" && _vm.editTimeslot
                ? _c("HandleTimeslotRecurring", {
                    attrs: {
                      timeslotView: _vm.timeslotView,
                      timeslotViewOptions: _vm.timeslotViewOptions,
                      client: _vm.clientDataInput,
                      timeslot: _vm.editTimeslot,
                      editState: ""
                    },
                    on: {
                      "set-timeslot-view": function($event) {
                        _vm.timeslotView = $event
                      },
                      cancel: function($event) {
                        _vm.process = "manage_schedule"
                      },
                      continue: function($event) {
                        _vm.process = "manage_schedule"
                      },
                      "after-commit": function($event) {
                        return _vm.fetchAvailbleCredits(_vm.clientDataInput.id)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.process === "review_appointment"
                ? _c("ReviewAppointmentRecurring", {
                    attrs: {
                      timeslotView: _vm.timeslotView,
                      timeslotViewOptions: _vm.timeslotViewOptions,
                      client: _vm.clientDataInput,
                      clientAppointments: _vm.clientAppointments
                    },
                    on: {
                      "set-timeslot-view": function($event) {
                        _vm.timeslotView = $event
                      },
                      "set-client-appointments": function($event) {
                        _vm.clientAppointments = $event
                      },
                      "delete-timeslot": _vm.onDeleteReviewedTimeslot
                    }
                  })
                : _vm._e()
            ],
            1
          ),
      _vm._v(" "),
      _vm.bookingStatus === "in_progress" &&
      (_vm.process === "manage_schedule" ||
        _vm.process === "review_appointment")
        ? _c(
            "div",
            {
              staticClass:
                "sticky bottom-0 left-0 flex items-center justify-between flex-shrink-0 h-20 px-6 border-t bg-pure-white border-slate-400",
              style: { zIndex: 99 }
            },
            [
              _c("div", { staticClass: "flex flex-col gap-2" }, [
                _c("div", { staticClass: "flex items-center gap-1" }, [
                  _c("div", {
                    staticClass: "w-20 h-1 rounded bg-light-purple"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "w-20 h-1 rounded",
                    class: [
                      _vm.process === "review_appointment"
                        ? "bg-light-purple"
                        : "bg-slate-400"
                    ]
                  })
                ]),
                _vm._v(" "),
                _vm.process === "manage_schedule"
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-1" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "grid flex-shrink-0 w-6 h-6 border rounded-full place-items-center",
                            class: [
                              _vm.isDisabledReview
                                ? "border-slate-600"
                                : "border-success-400"
                            ]
                          },
                          [
                            _vm.isDisabledReview
                              ? _c("BlTextSubtitle4", { attrs: { text: "1" } })
                              : _c("BlIcon", {
                                  staticClass: "w-6 h-6",
                                  attrs: { icon: "check", color: "success-4" }
                                })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BlTextSubtitle4", {
                          attrs: { text: "Manage timeslots and set recurrence" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.process === "review_appointment"
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-1" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "grid flex-shrink-0 w-6 h-6 border rounded-full place-items-center",
                            class: [
                              _vm.isDisabledSubmit
                                ? "border-slate-600"
                                : "border-success-400"
                            ]
                          },
                          [
                            _vm.isDisabledSubmit
                              ? _c("BlTextSubtitle4", { attrs: { text: "2" } })
                              : _c("BlIcon", {
                                  staticClass: "w-6 h-6",
                                  attrs: { icon: "check", color: "success-4" }
                                })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BlTextSubtitle4", {
                          attrs: { text: "Review and confirm appointments" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.process === "manage_schedule"
                    ? _c("BlInputButton", {
                        attrs: {
                          label: "Review all appointments",
                          disabled: _vm.isDisabledReview,
                          loading: _vm.reviewLoading
                        },
                        on: { clicked: _vm.onReview }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.process === "review_appointment"
                    ? _c(
                        "div",
                        { staticClass: "flex items-center gap-4" },
                        [
                          _c("BlInputButton", {
                            attrs: { type: "outlined", label: "Back" },
                            on: {
                              clicked: function($event) {
                                _vm.backOpened = true
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("BlInputButton", {
                            attrs: {
                              label:
                                "Book " +
                                _vm.bookingTimeslots.length +
                                " appointment(s)",
                              disabled: _vm.isDisabledSubmit,
                              loading: _vm.submitLoading
                            },
                            on: { clicked: _vm.onSubmit }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.previousOpened
        ? _c("PreviousRecurringSchedulesModal", {
            attrs: { clientId: _vm.clientDataInput.id },
            on: {
              "close-modal": function($event) {
                _vm.previousOpened = false
              },
              "after-commit": function($event) {
                return _vm.fetchAvailbleCredits(_vm.clientDataInput.id)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.closeOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Are you sure you want to close?",
                description:
                  "You have unsaved progress in your recurring appointment creation. What would you like to do?",
                label: "Confirm and close",
                submitLoading: _vm.closeLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.closeOpened = false
                },
                "backdrop-action": _vm.onCloseOverlay
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex flex-col gap-2 px-8",
                  style: { width: "40rem" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center justify-center w-full gap-1 transition-all duration-300 border rounded-lg cursor-pointer h-22",
                      class: [
                        _vm.closeProgress === "discard"
                          ? "border-light-purple"
                          : "border-slate-400"
                      ],
                      on: {
                        click: function($event) {
                          _vm.closeProgress = "discard"
                        }
                      }
                    },
                    [
                      _c("BlTextSubtitle3", {
                        class: {
                          "text-light-purple": _vm.closeProgress === "discard"
                        },
                        attrs: { text: "Close and discard all progress" }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody3", {
                        attrs: {
                          text: "Your appointment creation will be lost."
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center justify-center w-full gap-1 transition-all duration-300 border rounded-lg cursor-pointer h-22",
                      class: [
                        _vm.closeProgress === "save"
                          ? "border-light-purple"
                          : "border-slate-400"
                      ],
                      on: {
                        click: function($event) {
                          _vm.closeProgress = "save"
                        }
                      }
                    },
                    [
                      _c("BlTextSubtitle3", {
                        class: {
                          "text-light-purple": _vm.closeProgress === "save"
                        },
                        attrs: { text: "Close and save your progress" }
                      }),
                      _vm._v(" "),
                      _vm.bookingAppointment
                        ? _c(
                            "div",
                            [
                              _c("BlTextBody3", {
                                attrs: {
                                  text:
                                    "You can resume the appointment creation until"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody3", {
                                attrs: {
                                  text: _vm.displayDate({
                                    date: _vm.bookingAppointment.end_time,
                                    format: "HH:mm"
                                  })
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.backOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Are you sure you want to return to the previous step?",
              description:
                "If you return to the previous step, all appointments generated in this step will be lost. Are you sure you want to go back?",
              label: "Confirm",
              submitLoading: _vm.closeLoading,
              maxWidth: "36rem"
            },
            on: {
              "backdrop-close": function($event) {
                _vm.backOpened = false
              },
              "backdrop-action": _vm.onBack
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25db0570", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25db0570","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/overlay/NewRecurringAppointmentOverlay.vue
// module id = null
// module chunks = 